import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IIncidentReport, defaultValue } from 'app/shared/model/incident-report.model';

export const ACTION_TYPES = {
  FETCH_INCIDENTREPORT_LIST: 'incidentReport/FETCH_INCIDENTREPORT_LIST',
  FETCH_INCIDENTREPORT: 'incidentReport/FETCH_INCIDENTREPORT',
  CREATE_INCIDENTREPORT: 'incidentReport/CREATE_INCIDENTREPORT',
  UPDATE_INCIDENTREPORT: 'incidentReport/UPDATE_INCIDENTREPORT',
  DELETE_INCIDENTREPORT: 'incidentReport/DELETE_INCIDENTREPORT',
  RESET: 'incidentReport/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IIncidentReport>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type IncidentReportState = Readonly<typeof initialState>;

// Reducer

export default (state: IncidentReportState = initialState, action): IncidentReportState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_INCIDENTREPORT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_INCIDENTREPORT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_INCIDENTREPORT):
    case REQUEST(ACTION_TYPES.UPDATE_INCIDENTREPORT):
    case REQUEST(ACTION_TYPES.DELETE_INCIDENTREPORT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_INCIDENTREPORT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_INCIDENTREPORT):
    case FAILURE(ACTION_TYPES.CREATE_INCIDENTREPORT):
    case FAILURE(ACTION_TYPES.UPDATE_INCIDENTREPORT):
    case FAILURE(ACTION_TYPES.DELETE_INCIDENTREPORT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_INCIDENTREPORT_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_INCIDENTREPORT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_INCIDENTREPORT):
    case SUCCESS(ACTION_TYPES.UPDATE_INCIDENTREPORT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_INCIDENTREPORT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/incident-reports';

// Actions

export const getEntities: ICrudGetAllAction<IIncidentReport> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_INCIDENTREPORT_LIST,
  payload: axios.get<IIncidentReport>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IIncidentReport> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_INCIDENTREPORT,
    payload: axios.get<IIncidentReport>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IIncidentReport> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_INCIDENTREPORT,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IIncidentReport> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_INCIDENTREPORT,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IIncidentReport> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_INCIDENTREPORT,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.RESET,
  });
};
